import React from 'react';
import { CircularProgress } from '@mui/material';
import { createPortal } from 'react-dom';

import * as S from './styles';

function LoadingLockScreen() {
  return (
    <>
      {createPortal(
        <S.Container>
          <S.ContainerLoading>
            <CircularProgress size={50} />
          </S.ContainerLoading>
        </S.Container>
        , document.body
      )}
    </>
  )
}

export default LoadingLockScreen